module.exports = __webpack_public_path__ + "static/img/about_us_banner.abd042a5.png";